import {
  collection,
  doc,
  addDoc,
  getDocs,
  query,
  where,
  updateDoc,
  writeBatch,
  deleteField,
  Timestamp,
} from 'firebase/firestore';
import { db } from '../config/firebase';

export interface InventoryFolder {
  id: string;
  userId: string;
  name: string;
  createdAt: string;
}

const FOLDERS_COLLECTION = 'inventoryFolders';
const ITEMS_COLLECTION = 'inventoryItems';

export const createFolder = async (userId: string, name: string): Promise<InventoryFolder> => {
  const trimmed = name.trim();
  if (!trimmed) {
    throw new Error('O nome da pasta é obrigatório');
  }

  const createdAt = Timestamp.now();
  const docRef = await addDoc(collection(db, FOLDERS_COLLECTION), {
    userId,
    name: trimmed,
    createdAt,
  });

  return {
    id: docRef.id,
    userId,
    name: trimmed,
    createdAt: createdAt.toDate().toISOString(),
  };
};

export const getUserFolders = async (userId: string): Promise<InventoryFolder[]> => {
  const q = query(
    collection(db, FOLDERS_COLLECTION),
    where('userId', '==', userId)
  );
  const snapshot = await getDocs(q);

  const folders: InventoryFolder[] = [];
  snapshot.forEach((docSnap) => {
    const data = docSnap.data();
    folders.push({
      id: docSnap.id,
      userId: data.userId,
      name: data.name || '',
      createdAt: data.createdAt?.toDate ? data.createdAt.toDate().toISOString() : new Date().toISOString(),
    });
  });

  return folders.sort((a, b) => a.name.localeCompare(b.name));
};

export const renameFolder = async (folderId: string, name: string): Promise<void> => {
  const trimmed = name.trim();
  if (!trimmed) {
    throw new Error('O nome da pasta é obrigatório');
  }
  await updateDoc(doc(db, FOLDERS_COLLECTION, folderId), { name: trimmed });
};

export const deleteFolder = async (folderId: string, userId: string): Promise<void> => {
  const itemsQuery = query(
    collection(db, ITEMS_COLLECTION),
    where('userId', '==', userId),
    where('folderId', '==', folderId)
  );
  const itemsSnapshot = await getDocs(itemsQuery);

  const batch = writeBatch(db);
  itemsSnapshot.forEach((itemDoc) => {
    batch.update(itemDoc.ref, { folderId: deleteField(), updatedAt: Timestamp.now() });
  });
  batch.delete(doc(db, FOLDERS_COLLECTION, folderId));
  await batch.commit();
};
